import React, { Component } from 'react';
import Validator from 'validatorjs';
import { Row, Col, Form } from 'react-bootstrap';

import { Http } from '../../../../support';
import { FormControl } from '../../../../facturotopia';
import CfdiToJsonUploadForm from './CfdiToJsonUploadForm';
import Loading from '../../../../facturotopia/loading/Loading';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import DecimalForConceptos from '../../support/impuestos/DecimalForConceptos';
import ProcessCfdiToJsonInputConversion from '../../transformers/ProcessCfdiToJsonInputConversion';

class UsePreviousCfdiAsBaseInputForm extends Component {
  state = {};

  get rules() {
    return {
      cfdi_uuid: ['uuid'],
    };
  }

  get catalog() {
    return [
      {
        label: 'Selecciona',
        value: '',
      },
    ].concat(this.tipoDeRelacionCatalog);
  }

  componentDidMount() {
    // Buscar el cfdi del query
    if (!!this.props.uuid) {
      this.handleOnChange({
        cfdi_uuid: this.props.uuid,
      });
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
      isValid: validator.passes(),
    });

    return validator;
  }

  handleOnChange = (event) => {
    const data = {
      ...this.state.data,
      ...event,
    };

    const validator = this.validate(data);

    this.setState({
      data,
    });

    !!data.cfdi_uuid && validator.passes() && this.handleOnSearch(data.cfdi_uuid);
  };

  handleOnSearch = async (cfdiUuid) => {
    try {
      this.setState({
        busy: true,
      });

      const response = await Http.get(
        `/api/comprobantes/${cfdiUuid}?include=emisor.nomina,emisor.series,receptor.nomina,input`
      );

      let input = response.data.input;
      const metadata = input.Metadata;

      if (input['Emisor']['CP'] ?? false) {
        input.Emisor = {
          ...response.data.emisor,
          sucursal: { codigo_postal: input.Emisor.CP, id: metadata?.id_sucursal },
        };
      } else {
        input.Emisor = response.data.emisor;
      }

      input.Receptor = response.data.receptor;

      const { comprobante, related } = this.props;

      input.related = related;

      const data = ProcessCfdiToJsonInputConversion.make(input, comprobante);

      const additional = response.data.additional;

      data.Observaciones = !!additional.Observaciones ? additional.Observaciones : undefined;

      if (!!metadata.Decimales) {
        data.Decimales = metadata.Decimales;

        DecimalForConceptos.decimales = parseInt(metadata.Decimales);
      }

      this.props.onChange(data);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No fue posible leer tu factura. =(',
      });
    } finally {
      this.setState({
        busy: false,
      });
    }
  };

  render() {
    const { comprobante, simple, onChange } = this.props;
    const { data = {}, busy, isValid } = this.state;

    if (simple === true) {
      return <Loading />;
    }

    return (
      <>
        <Row>
          <Col
            sm="12"
            md="8"
          >
            <FormControl
              type="text"
              label="Clonar un comprobante?"
              name="cfdi_uuid"
              placeholder="Folio fiscal"
              help=""
              autoFocus
              rules={this.rules.cfdi_uuid}
              value={data.cfdi_uuid}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm="12"
            md="4"
          >
            <Form.Label className="d-block">&nbsp;</Form.Label>
            <LoadingButton
              className="mr-3"
              variant="primary"
              loading={busy}
              disabled={busy || !data.cfdi_uuid || !isValid}
              onClick={this.handleOnSearch.bind(this, data.cfdi_uuid)}
            >
              {busy ? 'Buscando...' : 'Buscar'}
            </LoadingButton>
          </Col>
        </Row>

        <Row>
          <Col className="pt-2">
            <p>
              El clonar un comprobante te permite cambiar solo los datos necesarios como método de pago o forma de pago,
              datos erróneos del receptor o de conceptos. Para poder utilizar esta opción el comprobante debe haber sido
              emitido desde nuestro sistema, solo ingresa el folio fiscal y automáticamente completaremos la
              información.
            </p>

            <ul>
              <li>
                Para comprobantes de egreso el folio fiscal se relacionará automáticamente usando cfdis relacionados.
              </li>
              <li>Para comprobantes de pagos se llenará el documento relacionado del complemento de pagos.</li>
            </ul>
          </Col>
        </Row>

        <Row>
          <Col className="py-2">
            <p>
              El comprobante no está en nuestro sistema? No te preocupes!!! Puedes subir tu xml y nosotros completamos
              la información por ti.
            </p>
            <CfdiToJsonUploadForm
              comprobante={comprobante}
              onChange={onChange}
            />
          </Col>
        </Row>

        <Row>
          <Col className="pt-2">
            <p>
              Si ninguna de las opciones anteriores funciona para ti será necesario llenar la información desde cero.
              Haz click en "Continuar".
            </p>

            {this.props.children}
          </Col>
        </Row>
      </>
    );
  }
}

export default UsePreviousCfdiAsBaseInputForm;
